import { render, staticRenderFns } from "./ReversibleTextField.vue?vue&type=template&id=c4f46ede&scoped=true&"
import script from "./ReversibleTextField.vue?vue&type=script&lang=js&"
export * from "./ReversibleTextField.vue?vue&type=script&lang=js&"
import style0 from "./ReversibleTextField.vue?vue&type=style&index=0&id=c4f46ede&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f46ede",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VTextField})
